var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartPer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 9.5,
    fill: "#27AB60",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3182_14735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5892 11.3269H16.3211C15.819 11.3269 15.4783 11.6641 15.4783 12.1612C15.4783 12.6582 15.819 12.9955 16.3211 12.9955H20.6789C21.8445 12.9955 22.8488 13.9895 22.8488 15.1433V18.2143C22.8488 19.3681 21.8445 20.3622 20.6789 20.3622H16.3211C15.3169 20.3622 14.474 19.7054 14.223 18.7823L12.6269 13.315L11.533 9.4275C11.2102 8.50445 10.3673 7.84766 9.36309 7.84766H7.35458C6.85245 7.84766 6.51172 8.18493 6.51172 8.68196C6.51172 9.17899 6.85245 9.51626 7.35458 9.51626H9.36309C9.61415 9.51626 9.86521 9.67602 9.95488 9.92453L11.1205 13.741L12.6269 19.2971C13.0394 20.9479 14.6354 22.1195 16.3211 22.1195H20.5892C22.6874 22.1195 24.4448 20.3799 24.4448 18.303V15.2143C24.4448 13.0665 22.7771 11.3269 20.5892 11.3269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3169 23.5898H14.6534C14.1513 23.5898 13.8105 23.9271 13.8105 24.4241C13.8105 24.9212 14.1513 25.2584 14.6534 25.2584H15.3169C15.8191 25.2584 16.1598 24.9212 16.1598 24.4241C16.1419 23.9094 15.8191 23.5898 15.3169 23.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8482 23.5898H22.1847C21.6825 23.5898 21.3418 23.9271 21.3418 24.4241C21.3418 24.9212 21.6825 25.2584 22.1847 25.2584H22.8482C23.3503 25.2584 23.691 24.9212 23.691 24.4241C23.691 23.9094 23.3503 23.5898 22.8482 23.5898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3182_14735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9331,
    height: 17.7511,
    fill: "white",
    transform: "translate(6.50977 7.67188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartPer);
export default __webpack_public_path__ + "static/media/CartPer.793ea8224ad40323858bde9e1d805ea2.svg";
export { ForwardRef as ReactComponent };